import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  giftWrappingTitle: {
    id: 'checkout.cartPage.serviceWrapper.giftWrapping',
    defaultMessage: 'Gift-wrap',
    description: 'Service gift wrapping title text',
  },
  giftWrappingTitleExtended: {
    id: 'checkout.cartPage.serviceWrapper.giftWrappingInfo',
    defaultMessage: 'individual products or the entire order',
    description: 'Service gift wrapping title extended text',
  },
  giftWrappingDescription: {
    id: 'checkout.cartPage.serviceWrapper.giftWrappingDescription',
    defaultMessage: 'We can pack everything for you in luxury gift wrap.',
    description: 'Service gift wrapping description text',
  },
  giftWrappingCantCombineDescription: {
    id: 'checkout.cartPage.serviceWrapper.giftWrappingCantCombineDescription',
    defaultMessage: 'Gift and eco wrapping cannot be combined. Only one of the options can be chosen.',
    description: 'Service gift and eco wrapping cannot be combined description text',
  },
  giftWithEcoCantCombineDescription: {
    id: 'checkout.cartPage.serviceWrapper.giftWithEcoCantCombineDescription',
    defaultMessage:
      'You have a gift packaging in the basket that unfortunately cannot be packaged in the eco wrapping.',
    description: 'Service gift and eco wrapping cannot be combined description text',
  },

  dicoveryWithEcoCantCombineDescription: {
    id: 'checkout.cartPage.serviceWrapper.dicoveryWithEcoCantCombineDescription',
    defaultMessage:
      'You have the Notino Discovery Box in the basket that unfortunately cannot be packaged in the eco wrapping.',
    description: 'Service dicovery box and eco wrapping cannot be combined description text',
  },
  giftWrappingLinkText: {
    id: 'checkout.cartPage.serviceWrapper.giftWrappingLinkText',
    defaultMessage: 'More info',
    description: 'Service gift wrapping link text',
  },
  ecoWrappingTitle: {
    id: 'checkout.cartPage.serviceWrapper.ecoWrapping',
    defaultMessage: 'Eco wrapping',
    description: 'Service eco wrapping title text',
  },
  ecoWrappingDescription: {
    id: 'checkout.cartPage.serviceWrapper.ecoWrappingDescription',
    defaultMessage: 'Help us save the environment and use plastic-free recycled materials for your wrapping.',
    description: 'Service eco wrapping description text',
  },
  insurance: {
    id: 'checkout.cartPage.serviceWrapper.insuranceTitle',
    defaultMessage: 'Insure your package',
    description: 'Service insurance title text',
  },
  insuranceDescription: {
    id: 'checkout.cartPage.serviceWrapper.insuranceDescription',
    defaultMessage:
      'In the event of damage or loss, there is no need to wait for the situation to be resolved by the statutory deadline. Just report and document your lost or damaged package to us and we will send out new products immediately.',
    description: 'Service insurance description text',
  },
  giftPackagingUnavailableTitle: {
    id: 'checkout.cartPage.serviceWrapper.giftPackagingNotAvailableTitle',
    defaultMessage: 'Unfortunately, we cannot wrap more gifts today.',
    description: 'Service girt packaging not available title',
  },
  giftPackagingUnavailableDescription: {
    id: 'checkout.cartPage.serviceWrapper.giftPackagingNotAvailableDescription',
    defaultMessage: 'Try again tomorrow.',
    description: 'Service girt packaging not available description',
  },
  serviceLegalInfo: {
    id: 'checkout.cartPage.serviceWrapper.serviceLegalInfo',
    defaultMessage:
      'By choosing this service, you agree that you will lose the right to withdraw from this service once it has been carried out.',
    description: 'Info Displayed in the InfoMarker Tooltip',
  },

  forFreePriceText: {
    id: 'checkout.cartPage.serviceWrapper.freePriceText',
    defaultMessage: 'free',
    description: 'Text displayed at each service if price is equal to zero',
  },

  fundRaiserTitle: {
    id: 'checkout.cartPage.serviceWrapper.FundRaiserTitle',
    defaultMessage: '{icon}Help Ukraine',
    description: 'Fund raiser title',
  },

  fundRaiserDescription: {
    id: 'checkout.cartPage.serviceWrapper.FundRaiserDescription',
    defaultMessage:
      'Donate {price} to help Ukraine and we will double the donation. All proceeds are going to be donated to UNICEF children fund.',
    description: 'Fund raiser description',
  },

  fundRaiserInfoBox: {
    id: 'checkout.cartPage.serviceWrapper.FundRaiserInfoBox',
    defaultMessage: 'All proceeds are going to be donated to UNICEF children fund to help during Ukraine crisis.',
    description: 'Fund raiser Info box',
  },
});
